(() => {
  if (customElements.get('vivanoura-cart-page')) return;

  const german = {
    'CHECKOUT PREPARATION': 'BESTELLUNG VORBEREITEN',
    'Your shopping cart': 'Ihr Warenkorb', 'Secure': 'Sicher',
    'Contact': 'Kontakt', 'Order updates will be sent to your email address': 'Bestellinformationen senden wir an Ihre E-Mail-Adresse.',
    'Email address': 'E-Mail-Adresse', 'Delivery address': 'Lieferadresse', 'Enter the address for this order': 'Geben Sie die Lieferadresse für diese Bestellung ein.',
    'First name': 'Vorname', 'Last name': 'Nachname', 'Street address': 'Straße und Hausnummer',
    'Apartment, suite, etc.': 'Wohnung, Etage usw.', 'Optional': 'Optional', 'City': 'Stadt',
    'State / province': 'Bundesland / Region', 'Postal code': 'Postleitzahl', 'Country / region': 'Land / Region',
    'Phone': 'Telefon', 'Payment': 'Zahlung',
    'PayPal is recommended for a faster, familiar checkout.': 'Wir empfehlen PayPal für eine schnelle und vertraute Bezahlung.',
    'RECOMMENDED': 'EMPFOHLEN', 'Continue securely with PayPal': 'Sicher mit PayPal fortfahren',
    'Fast and familiar. PayPal keeps your payment details with PayPal.': 'Schnell und vertraut. Ihre Zahlungsdaten bleiben bei PayPal.',
    'or pay by card': 'oder mit Karte bezahlen', 'Pay by card': 'Mit Karte bezahlen',
    'CHECKOUT SECURITY': 'SICHERE ZAHLUNG', 'Protected connection': 'Geschützte Verbindung',
    "Payment confirmation comes from the provider's signed callback. Returning to the store alone does not confirm payment.": 'Die Zahlung wird erst nach der Bestätigung durch den Zahlungsanbieter als abgeschlossen gewertet.',
    'HTTPS connection': 'HTTPS-Verbindung', 'Privacy policy': 'Datenschutzerklärung',
    'Today': 'Heute', 'Order placed': 'Bestellung aufgegeben', '1–3 business days': '1–3 Werktage',
    'Processing': 'Bearbeitung', '5–9 business days': '5–9 Werktage', 'Estimated delivery': 'Voraussichtliche Lieferung',
    'Day return request': 'Tage Rückgabefrist', 'STORE POLICIES': 'SHOP-RICHTLINIEN',
    '30-day return request period': 'Rückgabeanfrage innerhalb von 30 Tagen',
    'You may request a return within 30 calendar days after confirmed delivery, subject to the eligibility terms in our': 'Sie können innerhalb von 30 Kalendertagen nach bestätigter Lieferung eine Rückgabe gemäß unserer',
    'refund policy': 'Rückgaberichtlinie',
    '. Shipping methods and the best available delivery estimate are shown before payment.': ' beantragen. Versandart und voraussichtliche Lieferzeit werden vor der Zahlung angezeigt.',
    'DAYS': 'TAGE', 'RETURN REQUEST': 'RÜCKGABE', 'PAGE': 'SEITE', 'BUSINESS DAYS': 'WERKTAGE',
    'NORMAL PROCESSING': 'REGULÄRE BEARBEITUNG', 'EMAIL': 'E-MAIL', 'UPDATES': 'AKTUELLES',
    'ORDER STATUS': 'BESTELLSTATUS', 'PRIVACY': 'DATENSCHUTZ', 'POLICY': 'RICHTLINIE',
    'TRACK': 'SENDUNG', 'WHEN': 'WENN', 'AVAILABLE': 'VERFÜGBAR', 'INFO': 'INFO',
    'WHY VIVANOURA?': 'WARUM VIVANOURA?', 'Subject to the': 'Gemäß der',
    'Shipping updates': 'Versandinformationen', 'Tracking by email when available': 'Sendungsverfolgung per E-Mail, sobald verfügbar',
    'Order summary': 'Bestellübersicht', 'Estimated total': 'Voraussichtlicher Gesamtbetrag',
    'Estimated total is temporarily unavailable': 'Der Gesamtbetrag ist vorübergehend nicht verfügbar',
    'Payment is not confirmed yet': 'Ihre Zahlung ist noch nicht bestätigt',
    'You are back at your cart. If you did not finish paying, your order has not been confirmed. If you paid, please wait for your confirmation email or contact us before trying again.': 'Sie sind zum Warenkorb zurückgekehrt. Wenn Sie die Zahlung nicht abgeschlossen haben, ist Ihre Bestellung nicht bestätigt. Falls Sie bezahlt haben, warten Sie bitte auf die Bestätigungs-E-Mail oder kontaktieren Sie uns, bevor Sie es erneut versuchen.',
    'We are checking your payment': 'Wir prüfen Ihre Zahlung',
    'Please wait while we confirm your payment and order. Returning from the payment page alone does not confirm payment.': 'Bitte warten Sie, während wir Zahlung und Bestellung bestätigen. Die Rückkehr von der Zahlungsseite allein bestätigt keine Zahlung.',
    'Continue shopping': 'Weiter einkaufen', 'ORDER NOT FOUND': 'BESTELLUNG NICHT GEFUNDEN',
    'We could not find this payment session': 'Wir konnten diesen Zahlungsvorgang nicht finden',
    'Please check your order confirmation email or contact us. Do not pay again until your payment status is clear.': 'Prüfen Sie Ihre Bestätigungs-E-Mail oder kontaktieren Sie uns. Bezahlen Sie nicht erneut, solange der Zahlungsstatus unklar ist.',
    'ORDER CONFIRMED': 'BESTELLUNG BESTÄTIGT', 'Thank you — your order is confirmed': 'Vielen Dank – Ihre Bestellung ist bestätigt',
    'Your payment and order have been confirmed. We will send the order details to your email address.': 'Ihre Zahlung und Bestellung wurden bestätigt. Die Bestelldetails senden wir Ihnen per E-Mail.',
    'ORDER NEEDS REVIEW': 'BESTELLUNG WIRD GEPRÜFT', 'We are reviewing your order': 'Wir prüfen Ihre Bestellung',
    'Please do not pay again. We will check the payment and contact you about the next step.': 'Bitte bezahlen Sie nicht erneut. Wir prüfen die Zahlung und informieren Sie über die nächsten Schritte.',
    'PAYMENT NOT CONFIRMED': 'ZAHLUNG NICHT BESTÄTIGT', 'Your payment is not confirmed': 'Ihre Zahlung ist nicht bestätigt',
    'If you did not complete the payment, you can return to your cart. If you paid, please wait for confirmation before paying again.': 'Falls Sie nicht bezahlt haben, können Sie zum Warenkorb zurückkehren. Falls Sie bezahlt haben, warten Sie bitte auf die Bestätigung, bevor Sie erneut zahlen.',
    'Return to cart': 'Zurück zum Warenkorb', 'PAYMENT NOT YET CONFIRMED': 'ZAHLUNG NOCH NICHT BESTÄTIGT',
    'Your payment is not confirmed yet': 'Ihre Zahlung ist noch nicht bestätigt',
    'If you left the payment page without paying, return to your cart. If you paid, please wait for confirmation before trying again.': 'Falls Sie die Zahlungsseite ohne Zahlung verlassen haben, kehren Sie zum Warenkorb zurück. Falls Sie bezahlt haben, warten Sie bitte auf die Bestätigung.',
    'PAYMENT RECEIVED': 'ZAHLUNG EINGEGANGEN', 'We are completing your order': 'Wir schließen Ihre Bestellung ab',
    'Your payment has been received. Please do not pay again while we finish creating the Shopify order.': 'Ihre Zahlung ist eingegangen. Bitte bezahlen Sie nicht erneut, während wir Ihre Bestellung abschließen.',
    'We cannot check your order right now. Please check your confirmation email or contact us before paying again.': 'Wir können Ihre Bestellung derzeit nicht prüfen. Prüfen Sie Ihre E-Mails oder kontaktieren Sie uns, bevor Sie erneut bezahlen.',
    'Confirmation is taking longer than expected. Please check your email or contact us before paying again.': 'Die Bestätigung dauert länger als erwartet. Prüfen Sie Ihre E-Mails oder kontaktieren Sie uns, bevor Sie erneut bezahlen.',
    'Could not read the cart. Please refresh and try again.': 'Der Warenkorb konnte nicht geladen werden. Bitte aktualisieren Sie die Seite.',
    'Your cart is empty.': 'Ihr Warenkorb ist leer.',
    'The payment gateway is not ready yet. Please try again later.': 'Die Zahlungsseite ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
    'Payment setup is pending. Please wait before trying again.': 'Die Zahlung wird vorbereitet. Bitte warten Sie einen Moment.',
    'Payment checkout could not start. Please try again.': 'Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    'Payment checkout could not start.': 'Die Zahlung konnte nicht gestartet werden.'
  };

  const isGerman = () => document.documentElement.lang.toLowerCase().startsWith('de');
  const translate = (value) => isGerman() ? (german[value] || value) : value;
  const localize = (root) => {
    if (!isGerman() || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const value = node.nodeValue;
      const trimmed = value.trim();
      if (german[trimmed]) node.nodeValue = value.replace(trimmed, german[trimmed]);
    }
    root.querySelectorAll?.('[aria-label]').forEach((node) => {
      const label = node.getAttribute('aria-label');
      if (german[label]) node.setAttribute('aria-label', german[label]);
    });
  };

  class VivanouraCartPage extends HTMLElement {
    connectedCallback() {
      const previewParam = this.dataset.previewParam || 'vivanoura_cart_preview';
      const url = new URL(window.location.href);
      const isPublic = this.dataset.public === 'true';
      if (!/(?:^|\/)cart\/?$/.test(url.pathname) || (!isPublic && url.searchParams.get(previewParam) !== '1')) return;
      this.startLocalization();
      if (isPublic && url.searchParams.has('umipay_result')) {
        this.renderOrderResult(url.searchParams.get('umipay_result'));
        return;
      }
      if (isPublic && url.searchParams.get('umipay_return') === 'unconfirmed') {
        this.renderUnconfirmedReturn();
      }
      const template = this.querySelector('[data-vcp-template]');
      const summaryTemplate = this.querySelector('[data-vcp-summary-template]');
      const footer = document.querySelector('#main-cart-footer .cart__footer');
      const summary = document.querySelector('cart-items > .page-width');
      const cartItems = document.querySelector('cart-items');
      if (!(template instanceof HTMLTemplateElement) || !footer || !summary || cartItems?.classList.contains('is-empty')) return;

      document.body.classList.add('vcp-preview-active');
      if (isPublic) document.body.classList.add('vcp-public-active');
      const nativeFooter = footer.querySelector('.cart__blocks');
      if (nativeFooter) nativeFooter.dataset.vcpNativeFooter = 'true';
      const panel = template.content.cloneNode(true);
      localize(panel);
      footer.appendChild(panel);
      if (summaryTemplate instanceof HTMLTemplateElement) {
        const trust = summaryTemplate.content.cloneNode(true);
        localize(trust);
        summary.appendChild(trust);
      }
      const heading = summary.querySelector('.title--primary');
      if (heading) heading.textContent = translate('Order summary');
      const form = footer.querySelector('[data-vcp-form]');
      this.endpoint = this.dataset.endpoint;
      this.attemptNonce = crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) => byte.toString(16).padStart(2, '0')).join('');
      form?.addEventListener('submit', (event) => this.startCheckout(event));
      this.renderDeliveryEstimate();
      this.scheduleDeliveryRefresh();
      this.renderCartTotal();
      this.observer = new MutationObserver(() => this.scheduleCartTotal());
      this.observer.observe(summary, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.translationObserver?.disconnect();
      if (this.resultTimer) clearTimeout(this.resultTimer);
      if (this.totalFrame) cancelAnimationFrame(this.totalFrame);
      if (this.deliveryTimer) clearTimeout(this.deliveryTimer);
      document.body.classList.remove('vcp-preview-active');
      document.body.classList.remove('vcp-public-active');
      document.body.classList.remove('vcp-result-active');
    }

    startLocalization() {
      if (!isGerman()) return;
      const main = document.querySelector('#MainContent');
      if (!main) return;
      localize(main);
      this.translationObserver = new MutationObserver((records) => {
        for (const record of records) {
          if (record.type === 'characterData') {
            const node = record.target;
            const value = node.nodeValue;
            const trimmed = value.trim();
            if (german[trimmed]) node.nodeValue = value.replace(trimmed, german[trimmed]);
          } else {
            record.addedNodes.forEach((node) => {
              if (node.nodeType === Node.TEXT_NODE) {
                const value = node.nodeValue;
                const trimmed = value.trim();
                if (german[trimmed]) node.nodeValue = value.replace(trimmed, german[trimmed]);
              } else if (node.nodeType === Node.ELEMENT_NODE) localize(node);
            });
          }
        }
      });
      this.translationObserver.observe(main, { childList: true, subtree: true, characterData: true });
    }

    renderUnconfirmedReturn() {
      const main = document.querySelector('#MainContent');
      if (!main || main.querySelector('.vcp-unconfirmed-return')) return;
      const notice = document.createElement('section');
      notice.className = 'vcp-unconfirmed-return';
      notice.setAttribute('role', 'status');
      const title = document.createElement('h1');
      title.textContent = 'Payment is not confirmed yet';
      const detail = document.createElement('p');
      detail.textContent = 'You are back at your cart. If you did not finish paying, your order has not been confirmed. If you paid, please wait for your confirmation email or contact us before trying again.';
      notice.append(title, detail);
      main.prepend(notice);
    }

    renderOrderResult(token) {
      const main = document.querySelector('#MainContent');
      if (!main) return;
      document.body.classList.add('vcp-result-active');
      const panel = document.createElement('section');
      panel.className = 'vcp-order-result';
      panel.setAttribute('aria-labelledby', 'vcp-result-title');
      const add = (tag, className, value) => {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = value;
        panel.append(element);
        return element;
      };
      add('p', 'vcp-result-brand', 'Vivanoura');
      const eyebrow = add('p', 'vcp-result-eyebrow', 'ORDER STATUS');
      eyebrow.setAttribute('aria-live', 'polite');
      const heading = add('h1', 'vcp-result-title', 'We are checking your payment');
      heading.id = 'vcp-result-title';
      const detail = add('p', 'vcp-result-detail', 'Please wait while we confirm your payment and order. Returning from the payment page alone does not confirm payment.');
      detail.setAttribute('aria-live', 'polite');
      const action = add('a', 'vcp-result-action', 'Continue shopping');
      action.href = window.Shopify?.routes?.root || '/';
      main.prepend(panel);
      if (typeof token !== 'string' || !/^[A-Za-z0-9_-]{20,255}$/.test(token) || !this.dataset.endpoint) {
        eyebrow.textContent = 'ORDER NOT FOUND';
        heading.textContent = 'We could not find this payment session';
        detail.textContent = 'Please check your order confirmation email or contact us. Do not pay again until your payment status is clear.';
        return;
      }
      const statusUrl = new URL(`/v1/checkout-sessions/${encodeURIComponent(token)}/status`, this.dataset.endpoint);
      let attempts = 0;
      const poll = async () => {
        attempts++;
        try {
          const response = await fetch(statusUrl, { mode: 'cors', cache: 'no-store', headers: { accept: 'application/json' } });
          if (!response.ok) throw new Error('Order status unavailable');
          const state = await response.json();
          if (['SHOPIFY_ORDER_CREATED', 'CONVERSION_SENT'].includes(state.status) && state.shopifyOrderId) {
            panel.classList.add('vcp-order-result--confirmed');
            eyebrow.textContent = 'ORDER CONFIRMED';
            heading.textContent = 'Thank you — your order is confirmed';
            detail.textContent = 'Your payment and order have been confirmed. We will send the order details to your email address.';
            return;
          }
          if (['REFUND_REQUIRED', 'MANUAL_REVIEW', 'INVENTORY_CONFLICT', 'AMOUNT_MISMATCH', 'CURRENCY_MISMATCH'].includes(state.status)) {
            eyebrow.textContent = 'ORDER NEEDS REVIEW';
            heading.textContent = 'We are reviewing your order';
            detail.textContent = 'Please do not pay again. We will check the payment and contact you about the next step.';
            return;
          }
          if (['PAYMENT_FAILED', 'CANCELLED', 'EXPIRED'].includes(state.status)) {
            eyebrow.textContent = 'PAYMENT NOT CONFIRMED';
            heading.textContent = 'Your payment is not confirmed';
            detail.textContent = 'If you did not complete the payment, you can return to your cart. If you paid, please wait for confirmation before paying again.';
            action.textContent = 'Return to cart';
            action.href = `${window.Shopify?.routes?.root || '/'}cart`;
          } else if (state.status === 'CHECKOUT_OPEN') {
            eyebrow.textContent = 'PAYMENT NOT YET CONFIRMED';
            heading.textContent = 'Your payment is not confirmed yet';
            detail.textContent = 'If you left the payment page without paying, return to your cart. If you paid, please wait for confirmation before trying again.';
            action.textContent = 'Return to cart';
            action.href = `${window.Shopify?.routes?.root || '/'}cart`;
          } else if (['PAYMENT_PAID', 'SHOPIFY_COMPLETING'].includes(state.status)) {
            eyebrow.textContent = 'PAYMENT RECEIVED';
            heading.textContent = 'We are completing your order';
            detail.textContent = 'Your payment has been received. Please do not pay again while we finish creating the Shopify order.';
          }
        } catch {
          if (attempts >= 5) detail.textContent = 'We cannot check your order right now. Please check your confirmation email or contact us before paying again.';
        }
        if (attempts < 90) this.resultTimer = setTimeout(poll, 2000);
        else if (eyebrow.textContent === 'ORDER STATUS') detail.textContent = 'Confirmation is taking longer than expected. Please check your email or contact us before paying again.';
      };
      poll();
    }

    scheduleCartTotal() {
      if (this.totalFrame) return;
      this.totalFrame = requestAnimationFrame(() => {
        this.totalFrame = 0;
        this.renderCartTotal();
      });
    }

    async startCheckout(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = event.submitter;
      const paymentMethod = button?.dataset?.vcpPaymentMethod;
      if (!(form instanceof HTMLFormElement) || !['card', 'paypal'].includes(paymentMethod) || !this.endpoint || form.dataset.busy === 'true') return;
      const emailInput = form.elements.namedItem('email');
      if (emailInput instanceof HTMLInputElement) emailInput.value = String(emailInput.value).normalize('NFKC').replace(/\s+/g, '').trim();
      this.showError(form, '');
      if (!form.reportValidity()) return;
      const fields = new FormData(form);
      const actions = [...form.querySelectorAll('[data-vcp-payment-method]')];
      actions.forEach((action) => { action.disabled = true; });
      form.dataset.busy = 'true';
      this.setPaymentLoading(form, paymentMethod, true);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Could not read the cart. Please refresh and try again.');
        const cart = await cartResponse.json();
        if (!Array.isArray(cart.items) || cart.items.length === 0) throw new Error('Your cart is empty.');
        const value = (name) => String(fields.get(name) || '').trim();
        const payload = {
          cartReference: String(cart.token || '').slice(0, 255) || undefined,
          presentmentCurrency: String(cart.currency || '').toUpperCase(),
          paymentMethod,
          lines: cart.items.map((item) => ({
            variantId: String(item.variant_id), quantity: Number(item.quantity),
            ...(item.selling_plan_allocation?.selling_plan?.id ? { sellingPlanId: String(item.selling_plan_allocation.selling_plan.id) } : {})
          })),
          discountCodes: [],
          email: value('email'),
          shippingAddress: {
            firstName: value('firstName'), lastName: value('lastName'), address1: value('address1'),
            ...(value('address2') ? { address2: value('address2') } : {}),
            city: value('city'), ...(value('provinceCode') ? { provinceCode: value('provinceCode') } : {}),
            postalCode: value('postalCode'), countryCode: value('countryCode').toUpperCase(),
            ...(value('phone') ? { phone: value('phone') } : {})
          }
        };
        const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`${this.attemptNonce}:${JSON.stringify(payload)}`));
        const hash = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
        const response = await fetch(this.endpoint, {
          method: 'POST', mode: 'cors',
          headers: { 'content-type': 'application/json', 'idempotency-key': `vivanoura_${hash}` },
          body: JSON.stringify(payload)
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || typeof result.checkoutUrl !== 'string' || !result.checkoutUrl.startsWith('https://')) {
          const umipayMessage = {
            authentication_failed: 'Payment authentication failed. Please contact store support.',
            merchant_not_found: 'The payment merchant is not available. Please contact store support.',
            insufficient_balance: 'Payment is temporarily unavailable. Please try again later.',
            provider_configuration_missing: 'Payment is temporarily unavailable. Please try again later.',
            paypal_configuration_invalid: 'PayPal is temporarily unavailable. Please choose Card or try again later.',
            signature_missing: 'Payment authentication failed. Please contact store support.',
            gateway_unavailable: 'The payment provider is temporarily unavailable. Please try again later.',
            invalid_gateway_response: 'The payment provider returned an invalid response. Please try again later.',
            order_rejected: 'The payment provider rejected this checkout. Please try again later.'
          }[result.reason];
          throw new Error(result.error === 'payment_method_unavailable' ? 'The payment gateway is not ready yet. Please try again later.' :
            result.error === 'umipay_order_create_failed' ? (umipayMessage || 'Payment checkout could not start. Please try again.') :
            response.status === 202 ? 'Payment setup is pending. Please wait before trying again.' : 'Payment checkout could not start. Please try again.');
        }
        window.location.assign(result.checkoutUrl);
      } catch (error) {
        this.setPaymentLoading(form, paymentMethod, false);
        this.showError(form, error instanceof Error ? error.message : 'Payment checkout could not start.');
        actions.forEach((action) => { action.disabled = false; });
        form.dataset.busy = 'false';
      }
    }

    setPaymentLoading(form, paymentMethod, active) {
      let overlay = document.querySelector('[data-vcp-payment-loading]');
      if (active && !overlay) {
        overlay = document.createElement('div');
        overlay.className = 'vcp-payment-loading';
        overlay.dataset.vcpPaymentLoading = '';
        overlay.setAttribute('role', 'status');
        overlay.setAttribute('aria-live', 'polite');

        const card = document.createElement('div');
        card.className = 'vcp-payment-loading__card';
        const art = document.createElement('div');
        art.className = 'vcp-payment-loading__art';
        art.setAttribute('aria-hidden', 'true');
        art.innerHTML = '<span class="vcp-payment-loading__spark vcp-payment-loading__spark--one">✦</span><span class="vcp-payment-loading__wallet"><span class="vcp-payment-loading__face">•‿•</span></span><span class="vcp-payment-loading__spark vcp-payment-loading__spark--two">✦</span>';
        const loadingGerman = document.documentElement.lang.toLowerCase().startsWith('de');
        const title = document.createElement('strong');
        title.className = 'vcp-payment-loading__title';
        title.textContent = loadingGerman ? 'Sichere Zahlung wird vorbereitet…' : 'Preparing your secure payment…';
        const detail = document.createElement('span');
        detail.className = 'vcp-payment-loading__detail';
        detail.textContent = loadingGerman ? 'Die Zahlungsseite wird geöffnet. Das kann einige Sekunden dauern.' : 'Opening the payment page. This may take a few seconds.';
        const dots = document.createElement('span');
        dots.className = 'vcp-payment-loading__dots';
        dots.setAttribute('aria-hidden', 'true');
        dots.innerHTML = '<i></i><i></i><i></i>';
        card.append(art, title, detail, dots);
        overlay.append(card);
        document.body.append(overlay);
      }
      if (!overlay) return;
      overlay.hidden = !active;
      overlay.dataset.paymentMethod = paymentMethod || '';
      document.body.classList.toggle('vcp-payment-loading-active', active);
      if (form instanceof HTMLFormElement) {
        if (active) form.setAttribute('aria-busy', 'true');
        else form.removeAttribute('aria-busy');
      }
    }

    showError(form, message) {
      const error = form.querySelector('[data-vcp-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    }

    renderDeliveryEstimate() {
      const timeline = document.querySelector('[data-vcp-delivery-estimate]');
      if (!timeline) return;
      const today = startOfLocalDay(new Date());
      const locale = document.documentElement.lang || navigator.language || 'en';
      const formatDate = (day) => new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(day);
      const formatRange = (start, end) => `${formatDate(start)} – ${formatDate(end)}`;
      const processingMin = readPositiveInteger(timeline.dataset.processingMin, 1);
      const processingMax = Math.max(processingMin, readPositiveInteger(timeline.dataset.processingMax, 3));
      const deliveryMin = readPositiveInteger(timeline.dataset.deliveryMin, 5);
      const deliveryMax = Math.max(deliveryMin, readPositiveInteger(timeline.dataset.deliveryMax, 9));
      const set = (name, text) => {
        const value = timeline.querySelector(`[data-vcp-date="${name}"]`);
        if (value) value.textContent = text;
      };
      set('ordered', formatDate(today));
      set('ready', formatRange(addBusinessDays(today, processingMin), addBusinessDays(today, processingMax)));
      set('delivered', formatRange(addBusinessDays(today, deliveryMin), addBusinessDays(today, deliveryMax)));
    }

    scheduleDeliveryRefresh() {
      if (this.deliveryTimer) clearTimeout(this.deliveryTimer);
      const now = new Date();
      const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      this.deliveryTimer = setTimeout(() => {
        this.renderDeliveryEstimate();
        this.scheduleDeliveryRefresh();
      }, Math.max(1000, nextMidnight.getTime() - Date.now() + 500));
    }

    async renderCartTotal() {
      const target = document.querySelector('[data-vcp-total]');
      if (!target) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { accept: 'application/json' } });
        if (!response.ok) throw new Error('cart unavailable');
        const cart = await response.json();
        const currency = String(cart.currency || window.Shopify?.currency?.active || '').toUpperCase();
        const amount = Number(cart.total_price || 0) / 100;
        const formatted = currency ? new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount) : amount.toFixed(2);
        target.replaceChildren();
        const label = document.createElement('span');
        label.textContent = 'Estimated total';
        const value = document.createElement('strong');
        value.textContent = formatted;
        target.append(label, value);
      } catch {
        target.textContent = 'Estimated total is temporarily unavailable';
      }
    }
  }

  function startOfLocalDay(value) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12);
  }

  function addBusinessDays(value, days) {
    const result = new Date(value);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const weekday = result.getDay();
      if (weekday !== 0 && weekday !== 6) added++;
    }
    return result;
  }

  function readPositiveInteger(value, fallback) {
    const parsed = Number.parseInt(value || '', 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
  }

  customElements.define('vivanoura-cart-page', VivanouraCartPage);
})();

